module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesNatural.958ae06.webp";